export const LEGACY_MANUAL_MFA_PREFIX = 'manual-enforced-';

const normalizeString = (value) => (
  typeof value === 'string' ? value.trim().toLowerCase() : ''
);

export const getMfaFactorFriendlyName = (factor) => (
  typeof factor?.friendly_name === 'string'
    ? factor.friendly_name
    : typeof factor?.friendlyName === 'string'
      ? factor.friendlyName
      : ''
);

export const getMfaFactorType = (factor) => normalizeString(
  factor?.factor_type || factor?.factorType || factor?.type,
);

export const isLegacyManualMfaFactor = (factor) => (
  getMfaFactorFriendlyName(factor)
    .trim()
    .toLowerCase()
    .startsWith(LEGACY_MANUAL_MFA_PREFIX)
);

export const isVerifiedMfaFactor = (factor) => (
  normalizeString(factor?.status) === 'verified'
);

export const isVerifiedNonLegacyMfaFactor = (factor) => (
  isVerifiedMfaFactor(factor) && !isLegacyManualMfaFactor(factor)
);

export const isVerifiedNonLegacyTotpFactor = (factor) => (
  getMfaFactorType(factor) === 'totp' && isVerifiedNonLegacyMfaFactor(factor)
);

export const toMfaFactorArray = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }
  if (typeof payload === 'string') {
    try {
      return toMfaFactorArray(JSON.parse(payload));
    } catch {
      return [];
    }
  }
  if (Array.isArray(payload?.all) && payload.all.length > 0) {
    return payload.all;
  }

  const factors = [
    ...(Array.isArray(payload?.totp) ? payload.totp : []),
    ...(Array.isArray(payload?.phone) ? payload.phone : []),
    ...(Array.isArray(payload?.webauthn) ? payload.webauthn : []),
  ];

  const seen = new Set();
  return factors.filter((factor) => {
    const key = factor?.id || factor;
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};
